import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            // Small delay for better UX
            setTimeout(() => setIsVisible(true), 1000);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-in-up">
            <div className="bg-white border border-gray-100 shadow-[0_-8px_30px_rgba(0,0,0,0.12)] rounded-2xl p-6 max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-6 justify-between transform transition-all">
                <div className="flex items-start gap-4">
                    <div className="text-4xl hidden sm:block">🍪</div>
                    <div className="flex-1">
                        <h3 className="text-lg font-black text-gray-900 mb-1">Tu privacidad es importante</h3>
                        <p className="text-gray-500 text-sm leading-relaxed font-medium">
                            Utilizamos cookies para mejorar tu experiencia y analizar el uso de la plataforma.
                            Consulta nuestra <a href="#" className="text-primary-600 hover:text-primary-700 font-bold hover:underline">Política de Cookies</a>.
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-3 w-full md:w-auto flex-shrink-0">
                    <button
                        onClick={handleAccept} // Minimal implementation: close acts as accept or just dismiss. Standard usually has accept.
                        className="px-6 py-3 rounded-xl text-sm font-bold text-gray-500 hover:bg-gray-50 hover:text-gray-900 transition-colors w-full md:w-auto text-center border border-transparent hover:border-gray-200"
                    >
                        Configurar
                    </button>
                    <button
                        onClick={handleAccept}
                        className="px-8 py-3 rounded-xl text-sm font-black text-white bg-primary-600 hover:bg-primary-700 shadow-xl shadow-primary-600/20 transition-all transform hover:-translate-y-1 w-full md:w-auto text-center active:scale-95"
                    >
                        Aceptar Cookies
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
